import { render, staticRenderFns } from "./CreadorActividadesCRUD.vue?vue&type=template&id=c0153e58"
import script from "./CreadorActividadesCRUD.vue?vue&type=script&lang=js"
export * from "./CreadorActividadesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports